import { Link } from '#components/Link/Link';
import type { ArticleTeaser } from '#domains/resolver/board-section-data';

type Props = {
	author: ArticleTeaser['author'];
};

export function BoardSectionItemAuthor({ author }: Props) {
	if (!author) {
		return null;
	}

	if (!author.link) {
		return <span aria-label="Autor*in">{author.name}</span>;
	}

	return (
		<Link aria-label="Autor*in" title={`Zum Profil von ${author.name}`} href={author.link}>
			{author.name}
		</Link>
	);
}
